import { Box, Skeleton, useTheme } from "@mui/material";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

export const PropertiesListingSkeleton = () => {
  const theme = useTheme();
  const screen = useScreenSize();

  return (
    <Box
      sx={{
        backgroundColor: "#F9F9F9",
        borderRadius: theme.nawy.radius.xl,
        padding: theme.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.md,
        width: "100%",
      }}
    >
      {/* Title and Subtitle Skeletons */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.xxxs,
        }}
      >
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width={160} height={20} />
      </Box>
      {/* Grid Skeletons */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: theme.nawy.spacing.md,
          rowGap: theme.nawy.spacing.md,
          columnGap: theme.nawy.spacing["2xl"],
          width: "100%",
        }}
      >
        {[...Array(6)].map((_, idx) => (
          <Box
            key={idx}
            sx={{
              width: screen.isMobile ? "134px" : "159px",
              display: "flex",
              flexDirection: "column",
              gap: theme.nawy.spacing.xxs,
            }}
          >
            <Skeleton variant="text" width={80} height={18} />
            <Skeleton variant="text" width={100} height={22} />
          </Box>
        ))}
      </Box>
      {/* Button Skeleton */}
      <Box>
        <Skeleton
          variant="rectangular"
          width={90}
          height={32}
          sx={{ borderRadius: theme.nawy.radius["2xl"] }}
        />
      </Box>
    </Box>
  );
};

export default PropertiesListingSkeleton;
